module.exports = __webpack_public_path__ + "static/media/resultats_J2.00ce9e30.pdf";